export default {
    path: '/',
    component: () =>
        import ('../../views/Index.vue'),
    children: [{
        path: '',
        component: () =>
            import ('../../views/shanxi.vue'),
        meta: {
            title: '陕西省残疾人就业创业网络服务平台——陕西省残联官方残疾人求职网站',
            requireAuth: false,
            userType: 1
        },
    },
        {
            path: '/job',
            component: () =>
                import ('../../views/job/jobList.vue'),
            meta: {
                title: '求职招聘——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
            },
        },
        {
            path: '/job/jobDetail',
            component: () =>
                import ('../../views/job/jobDetail.vue'),
            meta: {
                title: '求职招聘——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
            },
        },
        {
            path: '/job/businessDetails',
            component: () =>
                import ('../../views/job/businessDetails.vue'),
            meta: {
                title: '求职招聘——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
            },
        },
        {
            path: '/train',
            component: () =>
                import ('../../views/shanxi-cdpe/train.vue'),
            meta: {
                title: '免费培训——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
            },
        },
        {
            path: '/training/trainDetail',
            component: () =>
                import ('../../views/training/trainDetail.vue'),
            meta: {
                title: '免费培训——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
            },
        },
        // {
        //     path: '/train',
        //     component: () =>
        //         import ('../../views/shanxi-cdpe/train.vue'),
        //     meta: {
        //         title: '免费培训——陕西省残疾人就业创业网络服务平台',
        //         requireAuth: false,
        //     },
        // },
        {
            path: '/news',
            component: () =>
                import ('../../views/shanxi-cdpe/news.vue'),
            meta: {
                title: '政策要闻——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/news/policyRead',
            component: () =>
                import ('../../views/shanxi-cdpe/news/policyRead.vue'),
            meta: {
                title: '政策解读——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/guide',
            component: () =>
                import ('../../views/shanxi-cdpe/guide/index.vue'),
            meta: {
                title: '就业指导——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/evaluation',
            component: () =>
                import ('../../views/shanxi-cdpe/evaluation/index.vue'),
            meta: {
                title: '能力测评——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/activity/help',
            component: () =>
                import ('../../views/shanxi-cdpe/activity/help/index.vue'),
            meta: {
                title: '就业帮扶——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/activity/help/list',
            component: () =>
                import ('../../views/shanxi-cdpe/activity/help/list.vue'),
            meta: {
                title: '就业帮扶——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/shopping',
            component: () =>
                import ('../../views/shoppingMall/Index'),
            meta: {
                title: '陕西商城——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/shopping/detail',
            component: () =>
                import ('../../views/shoppingMall/detail'),
            meta: {
                title: '陕西商城——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/skill',
            component: () =>
                import ('../../views/skill/index'),
            meta: {
                title: '职业技能竞赛——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/skill/list',
            component: () =>
                import ('../../views/skill/list'),
            meta: {
                title: '职业技能竞赛——陕西省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
    ]
}
